/** Height of the top bar, and of the brand block at the top of the side bar, so the two line up */
export const TOPBAR_HEIGHT = 52
